import type { UserState } from '../features/index.js'
import { useSelector } from './selector.hook.js'

export const useCurrentUser = (): UserState => {
  const user = useSelector(state => state.user)
  return user
}
